<template>
  <v-app id="inspire">
    <v-content fill-height fluid grid-list-xl app class="px-1">
      <titulo-responsivo titulo="Erro 404" />
      <v-divider />

      <h2 class="mt-4">{{ locale[local].screen.error404.string001 }}</h2>

      <v-btn @click="goHome()" color="primary" x-large class="mt-4 mr-4">
        {{ locale[local].screen.error404.string002 }}
      </v-btn>
    </v-content>
  </v-app>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push("/home");
    }
  }
};
</script>
